// Web: the browser's fetch already rejects network failures with TypeError.
